// extracted by mini-css-extract-plugin
export default {"topFooterInfo":"TopFooter_topFooterInfo__aXcmA"};